import * as urlWebservice from "utils/apis"
import * as actionsWebservice from "utils/functions/httpMethods"

// Find all packages
export const searchAllProducts = async ({ search = "", companyId = 1, subCompanyName } = {}) => {
  try {
    const query = {
      companyId,
      name: search,
      reference: search,
    }

    if (subCompanyName && subCompanyName !== "-") {
      query.subCompanyName = subCompanyName
    }
    const queryString = new URLSearchParams(query).toString()
    const results = await actionsWebservice.get(
      `${urlWebservice.SEARCH_PRODUCT}?${queryString}`,
      actionsWebservice.defaultManagementOptions()
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// create product management
export const createProductManagement = async (payload) => {
  try {
    const results = await actionsWebservice.post(
      urlWebservice.CREATE_PRODUCT_CMD,
      payload,
      actionsWebservice.defaultManagementOptions()
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Update product management
export const updateProductManagement = async (id, payload) => {
  try {
    const results = await actionsWebservice.putMethod(
      urlWebservice.UPDATE_PRODUCT_CMD(id),
      payload,
      actionsWebservice.defaultManagementOptions()
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Delete product management
export const deleteProductManagement = async (id) => {
  try {
    const results = await actionsWebservice.remove(
      urlWebservice.DELETE_PRODUCT_CMD(id),
      actionsWebservice.defaultManagementOptions()
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Get stock movement by reference
export const getStockMovementByRef = async (refPackage) => {
  try {
    const results = await actionsWebservice.get(
      urlWebservice.GET_STOCK_MOVEMENT_BY_REF(refPackage),
      actionsWebservice.defaultManagementOptions()
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}
